



  <section class="section-first section-md">
    <section class="sub-header">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-9">
              <div class="media align-items-center">
                <div class="media-left">
                  <div class="qualityScoreSection">
                    <svg viewBox="0 0 36 36" class="circular-chart red">
                      <path class="circle-bg"
                        d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      />
                      <path class="circle" stroke-dasharray="30,100"
                        d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      />
                      <text x="10" y="22" class="percentage" style="font-size: 10px; font-weight: 600;">25%</text>
                      <!-- <text x="9" y="22" class="percentage" style="font-size: 10px;font-weight: 600;" *ngIf="qualitySummary?.good?.percentage<=99 && qualitySummary?.good?.percentage>9">{{qualitySummary?.good?.percentage | number:'.0-0'}}%</text>
                      <text x="8" y="21" class="percentage" style="font-size: 8px;font-weight: 600;" *ngIf="qualitySummary?.good?.percentage>=100">{{qualitySummary?.good?.percentage | number:'.0-0'}}%</text> -->
                    </svg>
                  </div>
                </div>
                <div class="media-body">
                  <div class="section-title">
                    <h3>Citation Checker Report</h3>
                    <p>Sample Reference List.docx</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="search-box" *ngIf="creditsDetails['user_type']=='PREMIUM'">
                <a (click)="backToReferenceQuality()"[routerLink]="['/citation-check-tool']">Back to reports</a>
              </div>
            </div> -->
          </div>
        </div>
      </section>
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <ul class="nav nav-pills reference-tabs">
            <li class="nav-item">
              <a class="nav-link big active" data-toggle="pill" href="#Overview">Overview</a>
            </li>
            <li class="nav-item" >
              <a class="nav-link big" data-toggle="pill" href="#CitationsNeedAttention">Citations need Review</a>
            </li>
            <li class="nav-item" >
              <a class="nav-link" data-toggle="pill" href="#RetractedReferences">Retracted
                <span>3</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#OldReferences">Published Long Ago
                <span>12</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#JournalOveruse">Journal Bias
                <span>1</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#NonStandardReferences">Non-Standard
                <span>3</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#PoorCitations">Poorly Cited
                <span>9</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link big" data-toggle="pill" href="#goodCitations">Good-to-use Citations</a>
            </li>
          </ul>
        </div>

        <div class="col-lg-8">
            <div class="tab-content">
                <!-- Overview-->
                <div class="tab-pane active" id="Overview">
                  <div class="panel-card">
                    <h3>Citation Analysis Overview</h3>
                    <div class="row">
                      <div class="col-12 text-center">
                        <div class="graph-box">
                          <img src="assets/images/overview-graph.jpg" class="img-fluid" alt="graph" />
                        </div>
                      </div>
                    </div>

                    <div class="row match-box justify-content-center">
                      <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                        <div class="overview-card c-card high-border">
                          <div class="media">
                            <div class="media-left">
                              <div class="overview-right">
                                <h6 class="tx-high">12</h6>
                                <h1>High <br/>Risk</h1>
                              </div>
                            </div>
                            <div class="media-body high-border">
                              <div class="row">
                                <div class="col-6">
                                  <div class="overview-count">
                                    <h3>4</h3>
                                    <span>Retracted </span>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="overview-count">
                                    <h3>3</h3>
                                    <span>Non-Standard</span>
                                  </div>
                                </div>
                              </div>
                              <p>These citations highly likely weaken the strength of argumentation and must be replaced with credible alternatives.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                        <div class="overview-card c-card medium-border">
                          <div class="media">
                            <div class="media-left">
                              <div class="overview-right">
                                <h6 class="tx-medium">29</h6>
                                <h1>Medium <br/> Risk</h1>
                              </div>
                            </div>
                            <div class="media-body medium-border">
                              <div class="row">
                                <div class="col-6">
                                  <div class="overview-count">
                                    <h3>16</h3>
                                    <span>Old </span>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="overview-count">
                                    <h3>13</h3>
                                    <span>Poorly Cited</span>
                                  </div>
                                </div>
                              </div>
                              <p>These citations may weaken your argumentation. We highly recommend replacing with better alternatives.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row match-box justify-content-center">
                      <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                        <div class="overview-card c-card low-border">
                          <div class="media">
                            <div class="media-left">
                              <div class="overview-right">
                                <h6 class="tx-low">1</h6>
                                <h1>Low <br/>Risk</h1>
                              </div>
                            </div>
                            <div class="media-body low-border">
                              <div class="row">
                                <div class="col-12">
                                  <div class="overview-count">
                                    <h3>1</h3>
                                    <span>Journal Bias </span>
                                  </div>
                                </div>
                              </div>
                              <p>These citations may not adequately support your argumentation. Do review and replace with better alternative where possible.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-12 col-lg-6 col-12 dflex">
                        <div class="overview-card c-card success-border">
                          <div class="media">
                            <div class="media-left">
                              <div class="overview-right">
                                <h6 class="tx-success">15</h6>
                                <h1>No <br/>Risk</h1>
                              </div>
                            </div>
                            <div class="media-body success-border">
                              <div class="row">
                                <div class="col-12">
                                  <div class="overview-count">
                                    <h3>15</h3>
                                    <span>Good to use </span>
                                  </div>
                                </div>
                              </div>
                              <p>Our Al could not find any issues for these citations. You may review to ensure that these are credible for your research context. </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- CitationsNeedAttention -->
                <div class="tab-pane" id="CitationsNeedAttention">
                    <div class="panel-card">
                        <h3>41 out of 56 total citations need attention</h3>

                        <div  class="rf-accordion" id="accordion">
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne0">
                                   <ul  class="icon-list">
                                      <li >Gouaux E, MacKinnon R. Principles of selective ion transport in channels and pumps. science 2005; 310:1461-5.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   <li  class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne0">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Principles of Selective Ion Transport in Channels and Pumps</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Science</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Gouaux Eric et al. 
                                         <div  class="popover-content">
                                             <ul  class="ng-star-inserted"><li >Eric Gouaux</li></ul><ul  class="ng-star-inserted"><li >Roderick MacKinnon</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2005</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne1">
                                   <ul  class="icon-list">
                                      <li >Alberts B, Johnson A, Lewis J, Raff M, Roberts K, Walter P. Ion channels and the electrical properties of membranes.  Molecular Biology of the Cell 4th edition: Garland Science, 2002.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   <li  class="badge medium-risk ng-star-inserted">Published 38 years ago</li>
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne1">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Measuring the Properties of Single Channels in Cell Membranes</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Current Topics in Membranes and Transport</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Kolb H.-A. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >H.-A. Kolb</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 1984</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne2">
                                   <ul  class="icon-list">
                                      <li >Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   <li  class="badge medium-risk ng-star-inserted">Published 83 years ago</li>
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne2">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Action Potentials Recorded from Inside a Nerve Fibre</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Nature</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               HODGKIN A. L. et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >A. L. HODGKIN</li></ul><ul  class="ng-star-inserted"><li >A. F. HUXLEY</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 1939</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne3">
                                   <ul  class="icon-list">
                                      <li >Rubaiy HN. A short guide to electrophysiology and ion channels. Journal of Pharmacy &amp; Pharmaceutical Sciences 2017; 20:48-67.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne3">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> A Short Guide to Electrophysiology and Ion Channels</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Journal of Pharmacy &amp;amp; Pharmaceutical Sciences</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Rubaiy Hussein Nori 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Hussein Nori Rubaiy</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2017</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne4">
                                   <ul  class="icon-list">
                                      <li >Becchetti A, Arcangeli A. Integrins and ion channels in cell migration: implications for neuronal development, wound healing and metastatic spread.  Integrins and Ion Channels: Springer, 2010:107-23.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   <li  class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne4">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Integrins and Ion Channels in Cell Migration: Implications for Neuronal Development, Wound Healing and Metastatic Spread</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Advances in Experimental Medicine and Biology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Becchetti Andrea et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Andrea Becchetti</li></ul><ul  class="ng-star-inserted"><li >Annarosa Arcangeli</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne5">
                                   <ul  class="icon-list">
                                      <li >Pla AF, Avanzato D, Munaron L, Ambudkar IS. Ion channels and transporters in cancer. 6. Vascularizing the tumor: TRP channels as molecular targets. American Journal of Physiology-Cell Physiology 2012; 302:C9-C15.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne5">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Ion channels and transporters in cancer. 6. Vascularizing the tumor: TRP channels as molecular targets</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> American Journal of Physiology-Cell Physiology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Pla Alessandra Fiorio et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Alessandra Fiorio Pla</li></ul><ul  class="ng-star-inserted"><li >Daniele Avanzato</li></ul><ul  class="ng-star-inserted"><li >Luca Munaron</li></ul><ul  class="ng-star-inserted"><li >Indu S. Ambudkar</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2012</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne6">
                                   <ul  class="icon-list">
                                      <li >Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne6">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> The role of ion channels and transporters in cell proliferation and cancer</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Becchetti Andrea et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Andrea Becchetti</li></ul><ul  class="ng-star-inserted"><li >Luca Munaron</li></ul><ul  class="ng-star-inserted"><li >Annarosa Arcangeli</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2013</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne7">
                                   <ul  class="icon-list">
                                      <li >Lawson S. Phenotype and function of somatic primary afferent nociceptive neurones with C-, Aδ-or Aα/β-fibres. Experimental physiology 2002; 87:239-44.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 20 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne7">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Phenotype and Function of Somatic Primary Afferent Nociceptive Neurones with C-, Aδ- or Aα/β-Fibres</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Experimental Physiology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Lawson S. N. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >S. N. Lawson</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2002</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne8">
                                   <ul  class="icon-list">
                                      <li >Trimmer JS. Ion channels and pain: Important steps towards validating a new therapeutic target for neuropathic pain. Experimental neurology 2014; 254:190.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne8">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Ion channels and pain: Important steps towards validating a new therapeutic target for neuropathic pain</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Experimental Neurology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Trimmer James S. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >James S. Trimmer</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne9">
                                   <ul  class="icon-list">
                                      <li >Jardín I, López JJ, Diez R, Sánchez-Collado J, Cantonero C, Albarrán L, et al. TRPs in pain sensation. Frontiers in physiology 2017; 8:392.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne9">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> TRPs in Pain Sensation</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Jardín Isaac et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Isaac Jardín</li></ul><ul  class="ng-star-inserted"><li >José J. López</li></ul><ul  class="ng-star-inserted"><li >Raquel Diez</li></ul><ul  class="ng-star-inserted"><li >José Sánchez-Collado</li></ul><ul  class="ng-star-inserted"><li >Carlos Cantonero</li></ul><ul  class="ng-star-inserted"><li >Letizia Albarrán</li></ul><ul  class="ng-star-inserted"><li >Geoffrey E. Woodard</li></ul><ul  class="ng-star-inserted"><li >Pedro C. Redondo</li></ul><ul  class="ng-star-inserted"><li >Ginés M. Salido</li></ul><ul  class="ng-star-inserted"><li >Tarik Smani</li></ul><ul  class="ng-star-inserted"><li >Juan A. Rosado</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2017</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne10">
                                   <ul  class="icon-list">
                                      <li >Park J, Luo ZD. Calcium channel functions in pain processing. Channels 2010; 4:510-7.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne10">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Calcium channel functions in pain processing</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Channels</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Park John et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >John Park</li></ul><ul  class="ng-star-inserted"><li >Z. David Luo</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne11">
                                   <ul  class="icon-list">
                                      <li >Ranade Sanjeev&nbsp;S, Syeda R, Patapoutian A. Mechanically Activated Ion Channels. Neuron 2015; 87:1162-79.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne11">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Mechanically Activated Ion Channels</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Neuron</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Ranade Sanjeev&nbsp;S. et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Sanjeev&nbsp;S. Ranade</li></ul><ul  class="ng-star-inserted"><li >Ruhma Syeda</li></ul><ul  class="ng-star-inserted"><li >Ardem Patapoutian</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2015</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne12">
                                   <ul  class="icon-list">
                                      <li >Shah EA, Keren K. Mechanical forces and feedbacks in cell motility. Current opinion in cell biology 2013; 25:550-7.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne12">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Mechanical forces and feedbacks in cell motility</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Current Opinion in Cell Biology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Abu Shah Enas et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Enas Abu Shah</li></ul><ul  class="ng-star-inserted"><li >Kinneret Keren</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2013</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne13">
                                   <ul  class="icon-list">
                                      <li >Del Rio A, Perez-Jimenez R, Liu R, Roca-Cusachs P, Fernandez JM, Sheetz MP. Stretching single talin rod molecules activates vinculin binding. Science 2009; 323:638-41.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne14">
                                   <ul  class="icon-list">
                                      <li >Fuentes DE, Butler PJ. Coordinated mechanosensitivity of membrane rafts and focal adhesions. Cellular and molecular bioengineering 2012; 5:143-54.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne14">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Coordinated Mechanosensitivity of Membrane Rafts and Focal Adhesions</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Cellular and Molecular Bioengineering</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Fuentes Daniela E. et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >Daniela E. Fuentes</li></ul><ul  class="ng-star-inserted"><li >Peter J. Butler</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2012</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne15">
                                   <ul  class="icon-list">
                                      <li >Zhao Q, Zhou H, Chi S, Wang Y, Wang J, Geng J, et al. Structure and mechanogating mechanism of the Piezo1 channel. Nature 2018; 554:487.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne16">
                                   <ul  class="icon-list">
                                      <li >Guharay F, Sachs F. Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle. The Journal of physiology 1984; 352:685-701.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 38 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne16">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Stretch-activated single ion channel currents in tissue-cultured embryonic chick skeletal muscle.</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> The Journal of Physiology</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Guharay F et al. 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li >F Guharay</li></ul><ul  class="ng-star-inserted"><li >F Sachs</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 1984</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne17">
                                   <ul  class="icon-list">
                                      <li >Sharif-Naeini R, Folgering JH, Bichet D, Duprat F, Lauritzen I, Arhatte M, et al. Polycystin-1 and-2 dosage regulates pressure sensing. Cell 2009; 139:587-96.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne18">
                                   <ul  class="icon-list">
                                      <li >Goodman MB, Ernstrom GG, Chelur DS, O'Hagan R, Yao CA, Chalfie M. MEC-2 regulates C. elegans DEG/ENaC channels needed for mechanosensation. Nature 2002; 415:1039-42.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne19">
                                   <ul  class="icon-list">
                                      <li >Paoletti P, Ascher P. Mechanosensitivity of NMDA receptors in cultured mouse central neurons. Neuron 1994; 13:645-55.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 28 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne19">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Mechanosensitivity of NMDA receptors in cultured mouse central neurons</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Neuron"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Neuron</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Paoletti Pierre et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Paoletti Pierre et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Pierre Paoletti,Philippe Asche"
                                            }--><ul  class="ng-star-inserted"><li >Pierre Paoletti</li></ul><ul  class="ng-star-inserted"><li >Philippe Ascher</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 1994</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne20">
                                   <ul  class="icon-list">
                                      <li >Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne20">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Morris Catherine E."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Morris Catherine E. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Catherine E. Morris"
                                            }--><ul  class="ng-star-inserted"><li >Catherine E. Morris</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne21">
                                   <ul  class="icon-list">
                                      <li >Haswell ES, Phillips R, Rees DC. Mechanosensitive channels: what can they do and how do they do it? Structure (London, England : 1993) 2011; 19:1356-69.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne21">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Mechanosensitive Channels: What Can They Do and How Do They Do It?</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Structure"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Structure</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Haswell Elizabeth&nbsp;S. et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Haswell Elizabeth&nbsp;S. et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Elizabeth&nbsp;S. Haswell,Rob Phill"
                                            }--><ul  class="ng-star-inserted"><li >Elizabeth&nbsp;S. Haswell</li></ul><ul  class="ng-star-inserted"><li >Rob Phillips</li></ul><ul  class="ng-star-inserted"><li >Douglas&nbsp;C. Rees</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne22">
                                   <ul  class="icon-list">
                                      <li >Chalfie M. Neurosensory mechanotransduction. Nature reviews Molecular cell biology 2009; 10:44.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne22">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Neurosensory mechanotransduction</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature Reviews Molecular Cell "
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Nature Reviews Molecular Cell Biology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Chalfie Martin"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Chalfie Martin 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Martin Chalfie"
                                            }--><ul  class="ng-star-inserted"><li >Martin Chalfie</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2009</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne23">
                                   <ul  class="icon-list">
                                      <li >Vásquez V, Sotomayor M, Cordero-Morales J, Schulten K, Perozo E. A structural mechanism for MscS gating in lipid bilayers. Science 2008; 321:1210-4.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne23">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> A Structural Mechanism for MscS Gating in Lipid Bilayers</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Science"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Science</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Vásquez Valeria et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Vásquez Valeria et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Valeria Vásquez,Marcos Sotoma"
                                            }--><ul  class="ng-star-inserted"><li >Valeria Vásquez</li></ul><ul  class="ng-star-inserted"><li >Marcos Sotomayor</li></ul><ul  class="ng-star-inserted"><li >Julio Cordero-Morales</li></ul><ul  class="ng-star-inserted"><li >Klaus Schulten</li></ul><ul  class="ng-star-inserted"><li >Eduardo Perozo</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2008</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne24">
                                   <ul  class="icon-list">
                                      <li >Wang W, Black SS, Edwards MD, Miller S, Morrison EL, Bartlett W, et al. The structure of an open form of an E. coli mechanosensitive channel at 3.45 Å resolution. Science 2008; 321:1179-83.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne25">
                                   <ul  class="icon-list">
                                      <li >Brohawn SG, del Mármol J, MacKinnon R. Crystal structure of the human K2P TRAAK, a lipid-and mechano-sensitive K+ ion channel. Science 2012; 335:436-41.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne26">
                                   <ul  class="icon-list">
                                      <li >Maroto R, Raso A, Wood TG, Kurosky A, Martinac B, Hamill OP. TRPC1 forms the stretch-activated cation channel in vertebrate cells. Nature cell biology 2005; 7:179.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne26">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> TRPC1 forms the stretch-activated cation channel in vertebrate cells</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature Cell Biology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Nature Cell Biology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Maroto Rosario et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Maroto Rosario et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Rosario Maroto,Albert Raso,Tho"
                                            }--><ul  class="ng-star-inserted"><li >Rosario Maroto</li></ul><ul  class="ng-star-inserted"><li >Albert Raso</li></ul><ul  class="ng-star-inserted"><li >Thomas G. Wood</li></ul><ul  class="ng-star-inserted"><li >Alex Kurosky</li></ul><ul  class="ng-star-inserted"><li >Boris Martinac</li></ul><ul  class="ng-star-inserted"><li >Owen P. Hamill</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2005</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne27">
                                   <ul  class="icon-list">
                                      <li >Heimo Mairbäurl. Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells. Frontiers in Physiology 2013.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne27">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Mairbäurl Heimo"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Mairbäurl Heimo 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Heimo Mairbäurl"
                                            }--><ul  class="ng-star-inserted"><li >Heimo Mairbäurl</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2013</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne28">
                                   <ul  class="icon-list">
                                      <li >Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne28">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Ammonia production, excretion, toxicity, and defense in fish: a review</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Ip Yuen"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Ip Yuen 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Yuen Ip"
                                            }--><ul  class="ng-star-inserted"><li >Yuen Ip</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne29">
                                   <ul  class="icon-list">
                                      <li >Djuna Z. de Back, Elena B. Kostova, Marian van Kraaij, Timo K. van den Berg and Robin van Bruggen. Of macrophages and red blood cells; a complex love story. Frontiers in Physiology 2014.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne29">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Of macrophages and red blood cells; a complex love story</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "de Back Djuna Z. et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               de Back Djuna Z. et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Djuna Z. de Back,Elena B. Kost"
                                            }--><ul  class="ng-star-inserted"><li >Djuna Z. de Back</li></ul><ul  class="ng-star-inserted"><li >Elena B. Kostova</li></ul><ul  class="ng-star-inserted"><li >Marian van Kraaij</li></ul><ul  class="ng-star-inserted"><li >Timo K. van den Berg</li></ul><ul  class="ng-star-inserted"><li >Robin van Bruggen</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne30">
                                   <ul  class="icon-list">
                                      <li >SeongHun Yoon, Mario Zuccarello and Robert M. Rapoport. pCO2 and pH regulation of cerebral blood flow. Frontiers in Physiology 2010.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne30">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> pCO2 and pH regulation of cerebral blood flow</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Yoon SeongHun et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Yoon SeongHun et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "SeongHun Yoon,Mario Zuccarello"
                                            }--><ul  class="ng-star-inserted"><li >SeongHun Yoon</li></ul><ul  class="ng-star-inserted"><li >Mario Zuccarello</li></ul><ul  class="ng-star-inserted"><li >Robert M. Rapoport</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2012</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne31">
                                   <ul  class="icon-list">
                                      <li >Liu X., Zhang Y., Liang H. and Xu Y. Overexpression of microRNA-216a-3p Accelerates the Inflammatory Response in Cardiomyocytes in Type 2 Diabetes Mellitus by Targeting IFN-α2. (2020) Front. Endocrinol. 11:522340.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne31">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Overexpression of microRNA-216a-3p Accelerates the Inflammatory Response in Cardiomyocytes in Type 2 Diabetes Mellitus by Targeting IFN-α2</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Endocrinology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Endocrinology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Liu Xiaomeng et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Liu Xiaomeng et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Xiaomeng Liu,Yusong Zhang,Hong"
                                            }--><ul  class="ng-star-inserted"><li >Xiaomeng Liu</li></ul><ul  class="ng-star-inserted"><li >Yusong Zhang</li></ul><ul  class="ng-star-inserted"><li >Hongwei Liang</li></ul><ul  class="ng-star-inserted"><li >Yanchao Xu</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2020</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne32">
                                   <ul  class="icon-list">
                                      <li >Gao, X.-h., Zhang, S.-s., Chen, H., Wang, Y.-H., Yuan, C.-H., and Wang, F.-B. Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection. (2017). Front. Physiol. 8:480.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne32">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": ""
                                         }-->
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2018</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne33">
                                   <ul  class="icon-list">
                                      <li >Sarkar, A., Shukla, S. K., Alqatawni, A., Kumar, A., Addya, S., Tsygankov, A. Y., and Rafiq, K. The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart. Front. Cardiovasc. Med. 5:126.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne33">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Cardiovascular Me"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Cardiovascular Medicine</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": ""
                                         }-->
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2021</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne34">
                                   <ul  class="icon-list">
                                      <li >Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway. Front. Physiol. 2021 11:718.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne34">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Sun Qin et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Sun Qin et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Qin Sun,Tingxin Li,Yamei Li,Li"
                                            }--><ul  class="ng-star-inserted"><li >Qin Sun</li></ul><ul  class="ng-star-inserted"><li >Tingxin Li</li></ul><ul  class="ng-star-inserted"><li >Yamei Li</li></ul><ul  class="ng-star-inserted"><li >Lingling Wei</li></ul><ul  class="ng-star-inserted"><li >Min Zhang</li></ul><ul  class="ng-star-inserted"><li >Shaoping Deng</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2021</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne35">
                                   <ul  class="icon-list">
                                      <li >Estruch R, et al. Primary Prevention of Cardiovascular Disease with a Mediterranean Diet. N ENGL J MED; APR 2013.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne35">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Mediterranean Diet for Primary Prevention of Cardiovascular Disease</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "New England Journal of Medicin"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> New England Journal of Medicine</span></p>
                                      </div>
                                      <!--bindings={}-->
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne36">
                                   <ul  class="icon-list">
                                      <li >Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children. LANCET; FEB 28 1998.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne36">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction—Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "The Lancet"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> The Lancet</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "The Editors of The Lancet"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               The Editors of The Lancet 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": " The Editors of The Lancet"
                                            }--><ul  class="ng-star-inserted"><li > The Editors of The Lancet</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne37">
                                   <ul  class="icon-list">
                                      <li >Raj L, Ide T, Gurkar AU, Foley M, Schenone M, Li X, Tolliday NJ, Golub TR, Carr SA, Shamji AF, Stern AM, Mandinova A, Schreiber SL, Lee SW. Selective killing of cancer cells by a small molecule targeting the stress response to ROS. NATURE: JUL 2011.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne37">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Selective killing of cancer cells by a small molecule targeting the stress response to ROS</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature"
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Nature</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Raj Lakshmi et al."
                                         }-->
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               Raj Lakshmi et al. 
                                         <div  class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Lakshmi Raj,Takao Ide,Aditi U."
                                            }--><ul  class="ng-star-inserted"><li >Lakshmi Raj</li></ul><ul  class="ng-star-inserted"><li >Takao Ide</li></ul><ul  class="ng-star-inserted"><li >Aditi U. Gurkar</li></ul><ul  class="ng-star-inserted"><li >Michael Foley</li></ul><ul  class="ng-star-inserted"><li >Monica Schenone</li></ul><ul  class="ng-star-inserted"><li >Xiaoyu Li</li></ul><ul  class="ng-star-inserted"><li >Nicola J. Tolliday</li></ul><ul  class="ng-star-inserted"><li >Todd R. Golub</li></ul><ul  class="ng-star-inserted"><li >Steven A. Carr</li></ul><ul  class="ng-star-inserted"><li >Alykhan F. Shamji</li></ul><ul  class="ng-star-inserted"><li >Andrew M. Stern</li></ul><ul  class="ng-star-inserted"><li >Anna Mandinova</li></ul><ul  class="ng-star-inserted"><li >Stuart L. Schreiber</li></ul><ul  class="ng-star-inserted"><li >Sam W. Lee</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="" href="#collapseOne38">
                                   <ul  class="icon-list">
                                      <li >Voinnet O, Rivas S, Mestre P, Baulcombe D. An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus. PLANT J; MAR 2003.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <!--bindings={
                                   "ng-reflect-ng-if": "true"
                                   }-->
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   
                                </ul>
                                
                             </div>
                             
                             <div  class="collapse ng-star-inserted" id="collapseOne38">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: ‘An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus’</span></p>
                                      </div>
                                      
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> The Plant Journal</span></p>
                                      </div>
                                      <!--bindings={}-->
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2015</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne39">
                                   <ul  class="icon-list">
                                      <li >B Bredeweg and  Marco Kragten. Requirements and Challenges for Hybrid Intelligence: a Case-study in Education. Front. Artif. Intell. Sec. AI for Human Learning and Behavior Change. 2022</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link no-cursor" data-toggle="collapse" ng-reflect-klass="card-link" ng-reflect-ng-class="no-cursor" href="#collapseOne40">
                                   <ul  class="icon-list">
                                      <li >WHO Director-General’s opening remarks at the media briefing on COVID-19 - 11 March 2020.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                
                                <ul  class="ng-star-inserted">
                                   
                                   <li  class="badge high-risk ng-star-inserted">Not a standard, reviewed publication</li>
                                </ul>
                             </div>
                             
                          </div>
                       </div>
                    </div>
                </div>

                <!-- RetractedReferences -->
                <div class="tab-pane" id="RetractedReferences">
                    <div class="panel-card">
                        <h3>Retracted: 3 citations out of 54 <span class="badge high-risk">High Risk</span></h3>
                        <div class="warning mt-4 mb-4">
                            <div class="media">
                              <div class="media-left">
                                <img src="assets/images/Icon_Info.svg" alt="info">
                              </div>
                              <div class="media-body">
                                <p>A retracted citation is one that was published by a journal but is later recalled for research
                                  quality, integrity, or other ethical reasons. You should never cite a retracted paper as that
                                  seriously impacts the credibility of your argumentation. </p>
                              </div>
                            </div>
                        </div>

                        <div class="danger-outline mb-4 ">
                            Action Required: You will have to remove or replace these citations with more credible articles
                        </div>

                        <div  class="rf-accordion" id="accordion">
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" href="#collapseFour0">
                                   <ul  class="icon-list">
                                      <li > Gao, X.-h., Zhang, S.-s., Chen, H., Wang, Y.-H., Yuan, C.-H., and Wang, F.-B. Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection. (2017). Front. Physiol. 8:480.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="limitText" >
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   <li  class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                   <li  class="ng-star-inserted"><a  class="read-more"  (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div  class="collapse" data-parent="#accordion" id="collapseFour0">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2018</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" href="#collapseFour1">
                                   <ul  class="icon-list">
                                      <li > Sarkar, A., Shukla, S. K., Alqatawni, A., Kumar, A., Addya, S., Tsygankov, A. Y., and Rafiq, K. The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart. Front. Cardiovasc. Med. 5:126.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="limitText" >
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                </ul>
                             </div>
                             <div  class="collapse" data-parent="#accordion" id="collapseFour1">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: The Role of Allograft Inflammatory Factor-1 in the Effects of Experimental Diabetes on B Cell Functions in the Heart</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> Frontiers in Cardiovascular Medicine</span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2021</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" href="#collapseFour2">
                                   <ul  class="icon-list">
                                      <li > Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children. LANCET; FEB 28 1998.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="limitText" >
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                   <li  class="badge medium-risk hide-li ng-star-inserted">Published 12 years ago</li>
                                   <li  class="ng-star-inserted"><a  class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div  class="collapse" data-parent="#accordion" id="collapseFour2">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction—Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> The Lancet</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para">
                                            <b >Author:</b>
                                            <span  class="popover-item">
                                               The Editors of The Lancet 
                                         <div  class="popover-content"><ul  class="ng-star-inserted"><li > The Editors of The Lancet</li></ul></div></span></p>
                                      </div>
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div  class="card ng-star-inserted">
                             <div  class="card-header">
                                <a  class="card-link" data-toggle="collapse" href="#collapseFour3">
                                   <ul  class="icon-list">
                                      <li > Voinnet O, Rivas S, Mestre P, Baulcombe D. An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus. PLANT J; MAR 2003.</li>
                                   </ul>
                                </a>
                             </div>
                             <div  class="checklist-tags">
                                <ul  class="limitText" >
                                   <li  class="badge high-risk ng-star-inserted">Retracted after publication</li>
                                </ul>
                             </div>
                             <div  class="collapse" data-parent="#accordion" id="collapseFour3">
                                <div  class="card-body">
                                   <div  class="row">
                                      <div  class="col-12">
                                         <p  class="pc-para pc-title"><b >Title:</b><span> Retraction: ‘An enhanced transient expression system in plants based on suppression of gene silencing by the p19 protein of tomato bushy stunt virus’</span></p>
                                      </div>
                                      <div  class="col-sm-12 ng-star-inserted">
                                         <p  class="pc-para"><b >Journal:</b><span> The Plant Journal</span></p>
                                      </div>
                                     
                                      <div  class="col-12">
                                         <p  class="pc-para"><b >Published:</b><span> 2015</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                </div>

                <!-- OldReferences -->
                <div class="tab-pane" id="OldReferences">
                    <div class="panel-card">
                        <h3>Published Long Ago: 12 citations out of 54 <span class="badge medium-risk">Medium Risk</span></h3>
                        <div class="warning mt-4 mb-4">
                            <div class="media">
                              <div class="media-left">
                                <img src="assets/images/Icon_Info.svg" alt="info">
                              </div>
                              <div class="media-body">
                                <p>An old citations is one that was published over 10 years before the year of creation of this report. Journals prefer newer citations as they reflect the current status of research on the topic. Note that some old citations may be seminal works and hence would be acceptable (groundbreaking works).</p>
                              </div>
                            </div>
                        </div>

                        <div class="danger-outline mb-4 ">
                            Action Required: Review and replace these citations with newer citations published in peer-reviewed journals.
                        </div>

                        <div class="rf-accordion" id="accordion">
                          <!--bindings={
                             "ng-reflect-ng-for-of": "[object Object],[object Object"
                             }-->
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven0">
                                   <ul class="icon-list">
                                      <li>Gouaux E, MacKinnon R. Principles of selective ion transport in channels and pumps. science 2005; 310:1461-5. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven0">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Principles of Selective Ion Transport in Channels and Pumps</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Science"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Gouaux Eric et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Gouaux Eric et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Eric Gouaux,Roderick MacKinnon"
                                            }--><ul class="ng-star-inserted"><li>Eric Gouaux</li></ul><ul class="ng-star-inserted"><li>Roderick MacKinnon</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2005</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven1">
                                   <ul class="icon-list">
                                      <li>Alberts B, Johnson A, Lewis J, Raff M, Roberts K, Walter P. Ion channels and the electrical properties of membranes.  Molecular Biology of the Cell 4th edition: Garland Science, 2002. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 38 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk hide-li ng-star-inserted">Cited less than 3 times in a year</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven1">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Measuring the Properties of Single Channels in Cell Membranes</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Current Topics in Membranes an"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Current Topics in Membranes and Transport</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Kolb H.-A."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Kolb H.-A. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "H.-A. Kolb"
                                            }--><ul class="ng-star-inserted"><li>H.-A. Kolb</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 1984</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven2">
                                   <ul class="icon-list">
                                      <li>Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 83 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk hide-li ng-star-inserted">Cited less than 3 times in a year</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven2">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Action Potentials Recorded from Inside a Nerve Fibre</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "HODGKIN A. L. et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               HODGKIN A. L. et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "A. L. HODGKIN,A. F. HUXLEY"
                                            }--><ul class="ng-star-inserted"><li>A. L. HODGKIN</li></ul><ul class="ng-star-inserted"><li>A. F. HUXLEY</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 1939</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven3">
                                   <ul class="icon-list">
                                      <li>Becchetti A, Arcangeli A. Integrins and ion channels in cell migration: implications for neuronal development, wound healing and metastatic spread.  Integrins and Ion Channels: Springer, 2010:107-23. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk hide-li ng-star-inserted">Cited less than 3 times in a year</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven3">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Integrins and Ion Channels in Cell Migration: Implications for Neuronal Development, Wound Healing and Metastatic Spread</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Advances in Experimental Medic"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Advances in Experimental Medicine and Biology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Becchetti Andrea et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Becchetti Andrea et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Andrea Becchetti,Annarosa Arca"
                                            }--><ul class="ng-star-inserted"><li>Andrea Becchetti</li></ul><ul class="ng-star-inserted"><li>Annarosa Arcangeli</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven4">
                                   <ul class="icon-list">
                                      <li>Lawson S. Phenotype and function of somatic primary afferent nociceptive neurones with C-, Aδ-or Aα/β-fibres. Experimental physiology 2002; 87:239-44. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 20 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven4">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Phenotype and Function of Somatic Primary Afferent Nociceptive Neurones with C-, Aδ- or Aα/β-Fibres</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Experimental Physiology"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Experimental Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Lawson S. N."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Lawson S. N. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "S. N. Lawson"
                                            }--><ul class="ng-star-inserted"><li>S. N. Lawson</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2002</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven5">
                                   <ul class="icon-list">
                                      <li>Park J, Luo ZD. Calcium channel functions in pain processing. Channels 2010; 4:510-7. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven5">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Calcium channel functions in pain processing</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Channels"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Channels</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Park John et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Park John et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "John Park,Z. David Luo"
                                            }--><ul class="ng-star-inserted"><li>John Park</li></ul><ul class="ng-star-inserted"><li>Z. David Luo</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven6">
                                   <ul class="icon-list">
                                      <li>Guharay F, Sachs F. Stretch‐activated single ion channel currents in tissue‐cultured embryonic chick skeletal muscle. The Journal of physiology 1984; 352:685-701. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 38 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven6">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Stretch-activated single ion channel currents in tissue-cultured embryonic chick skeletal muscle.</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "The Journal of Physiology"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> The Journal of Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Guharay F et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Guharay F et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "F Guharay,F Sachs"
                                            }--><ul class="ng-star-inserted"><li>F Guharay</li></ul><ul class="ng-star-inserted"><li>F Sachs</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 1984</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven7">
                                   <ul class="icon-list">
                                      <li>Paoletti P, Ascher P. Mechanosensitivity of NMDA receptors in cultured mouse central neurons. Neuron 1994; 13:645-55. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 28 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven7">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Mechanosensitivity of NMDA receptors in cultured mouse central neurons</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Neuron"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Neuron</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Paoletti Pierre et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Paoletti Pierre et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Pierre Paoletti,Philippe Asche"
                                            }--><ul class="ng-star-inserted"><li>Pierre Paoletti</li></ul><ul class="ng-star-inserted"><li>Philippe Ascher</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 1994</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven8">
                                   <ul class="icon-list">
                                      <li>Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven8">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Morris Catherine E."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Morris Catherine E. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Catherine E. Morris"
                                            }--><ul class="ng-star-inserted"><li>Catherine E. Morris</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven9">
                                   <ul class="icon-list">
                                      <li>Haswell ES, Phillips R, Rees DC. Mechanosensitive channels: what can they do and how do they do it? Structure (London, England : 1993) 2011; 19:1356-69. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven9">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Mechanosensitive Channels: What Can They Do and How Do They Do It?</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Structure"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Structure</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Haswell Elizabeth&nbsp;S. et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Haswell Elizabeth&nbsp;S. et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Elizabeth&nbsp;S. Haswell,Rob Phill"
                                            }--><ul class="ng-star-inserted"><li>Elizabeth&nbsp;S. Haswell</li></ul><ul class="ng-star-inserted"><li>Rob Phillips</li></ul><ul class="ng-star-inserted"><li>Douglas&nbsp;C. Rees</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven10">
                                   <ul class="icon-list">
                                      <li>Chalfie M. Neurosensory mechanotransduction. Nature reviews Molecular cell biology 2009; 10:44. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 13 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven10">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Neurosensory mechanotransduction</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature Reviews Molecular Cell "
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Nature Reviews Molecular Cell Biology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Chalfie Martin"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Chalfie Martin 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Martin Chalfie"
                                            }--><ul class="ng-star-inserted"><li>Martin Chalfie</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2009</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven11">
                                   <ul class="icon-list">
                                      <li>Vásquez V, Sotomayor M, Cordero-Morales J, Schulten K, Perozo E. A structural mechanism for MscS gating in lipid bilayers. Science 2008; 321:1210-4. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 14 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven11">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> A Structural Mechanism for MscS Gating in Lipid Bilayers</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Science"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Science</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Vásquez Valeria et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Vásquez Valeria et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Valeria Vásquez,Marcos Sotoma"
                                            }--><ul class="ng-star-inserted"><li>Valeria Vásquez</li></ul><ul class="ng-star-inserted"><li>Marcos Sotomayor</li></ul><ul class="ng-star-inserted"><li>Julio Cordero-Morales</li></ul><ul class="ng-star-inserted"><li>Klaus Schulten</li></ul><ul class="ng-star-inserted"><li>Eduardo Perozo</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2008</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven12">
                                   <ul class="icon-list">
                                      <li>Maroto R, Raso A, Wood TG, Kurosky A, Martinac B, Hamill OP. TRPC1 forms the stretch-activated cation channel in vertebrate cells. Nature cell biology 2005; 7:179. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 17 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven12">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> TRPC1 forms the stretch-activated cation channel in vertebrate cells</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature Cell Biology"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Nature Cell Biology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Maroto Rosario et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Maroto Rosario et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Rosario Maroto,Albert Raso,Tho"
                                            }--><ul class="ng-star-inserted"><li>Rosario Maroto</li></ul><ul class="ng-star-inserted"><li>Albert Raso</li></ul><ul class="ng-star-inserted"><li>Thomas G. Wood</li></ul><ul class="ng-star-inserted"><li>Alex Kurosky</li></ul><ul class="ng-star-inserted"><li>Boris Martinac</li></ul><ul class="ng-star-inserted"><li>Owen P. Hamill</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2005</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven13">
                                   <ul class="icon-list">
                                      <li>Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge low-risk hide-li ng-star-inserted">Publishing journal used too many times</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven13">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Ammonia production, excretion, toxicity, and defense in fish: a review</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Frontiers in Physiology"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Ip Yuen"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Ip Yuen 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Yuen Ip"
                                            }--><ul class="ng-star-inserted"><li>Yuen Ip</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven14">
                                   <ul class="icon-list">
                                      <li>Wakefield AJ, Murch SH, Anthony A, Linnell J, Casson DM, Malik M, Berelowitz M, Dhillon AP, Thomson MA, Harvey P, Valentine A, Davies SE, Walker-Smith JA. Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children. LANCET; FEB 28 1998. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 12 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge high-risk hide-li ng-star-inserted">Retracted after publication</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven14">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Retraction—Ileal-lymphoid-nodular hyperplasia, non-specific colitis, and pervasive developmental disorder in children</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "The Lancet"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> The Lancet</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "The Editors of The Lancet"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               The Editors of The Lancet 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": " The Editors of The Lancet"
                                            }--><ul class="ng-star-inserted"><li> The Editors of The Lancet</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="card ng-star-inserted">
                             <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapseSeven15">
                                   <ul class="icon-list">
                                      <li>Raj L, Ide T, Gurkar AU, Foley M, Schenone M, Li X, Tolliday NJ, Golub TR, Carr SA, Shamji AF, Stern AM, Mandinova A, Schreiber SL, Lee SW. Selective killing of cancer cells by a small molecule targeting the stress response to ROS. NATURE: JUL 2011. </li>
                                   </ul>
                                </a>
                             </div>
                             <div class="checklist-tags">
                                <ul class="limitText">
                                   <!--bindings={
                                      "ng-reflect-ng-if": "true"
                                      }-->
                                   <li class="badge medium-risk ng-star-inserted">Published 11 years ago</li>
                                   <!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }--><!--bindings={
                                      "ng-reflect-ng-if": "false"
                                      }-->
                                </ul>
                             </div>
                             <div class="collapse" data-parent="#accordion" id="collapseSeven15">
                                <div class="card-body">
                                   <div class="row">
                                      <div class="col-12">
                                         <p class="pc-para pc-title"><b>Title:</b><span> Selective killing of cancer cells by a small molecule targeting the stress response to ROS</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Nature"
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para"><b>Journal:</b><span> Nature</span></p>
                                      </div>
                                      <!--bindings={
                                         "ng-reflect-ng-if": "Raj Lakshmi et al."
                                         }-->
                                      <div class="col-sm-12 ng-star-inserted">
                                         <p class="pc-para">
                                            <b>Author:</b>
                                            <span class="popover-item">
                                               Raj Lakshmi et al. 
                                         <div class="popover-content"><!--bindings={
                                            "ng-reflect-ng-for-of": "Lakshmi Raj,Takao Ide,Aditi U."
                                            }--><ul class="ng-star-inserted"><li>Lakshmi Raj</li></ul><ul class="ng-star-inserted"><li>Takao Ide</li></ul><ul class="ng-star-inserted"><li>Aditi U. Gurkar</li></ul><ul class="ng-star-inserted"><li>Michael Foley</li></ul><ul class="ng-star-inserted"><li>Monica Schenone</li></ul><ul class="ng-star-inserted"><li>Xiaoyu Li</li></ul><ul class="ng-star-inserted"><li>Nicola J. Tolliday</li></ul><ul class="ng-star-inserted"><li>Todd R. Golub</li></ul><ul class="ng-star-inserted"><li>Steven A. Carr</li></ul><ul class="ng-star-inserted"><li>Alykhan F. Shamji</li></ul><ul class="ng-star-inserted"><li>Andrew M. Stern</li></ul><ul class="ng-star-inserted"><li>Anna Mandinova</li></ul><ul class="ng-star-inserted"><li>Stuart L. Schreiber</li></ul><ul class="ng-star-inserted"><li>Sam W. Lee</li></ul></div></span></p>
                                      </div>
                                      <div class="col-12">
                                         <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                </div>

                <!-- JournalOveruse -->
                <div class="tab-pane" id="JournalOveruse">
                    <div class="panel-card">
                        <h3>Journal Bias: 16% of citations are from 1 Journals  <span class="badge low-risk">Low Risk</span></h3>
                        <div class="warning mt-4 mb-4">
                            <div class="media">
                              <div class="media-left">
                                <img src="assets/images/Icon_Info.svg" alt="info">
                              </div>
                              <div class="media-body">
                                <p>Journal bias implies citing too many papers from a particular journal. This could be considered unethical practice to favour a particular journal. The report below helps you identify which journals have been cited too many times.</p>
                              </div>
                            </div>
                        </div>

                        <div class="danger-outline mb-4 ">
                            Action Required: Review every citation and replace with credible alternatives from other peer-reviewed journals.
                        </div>

                        <div class="rf-accordion" id="accordion10">
                          <!--bindings={
                             "ng-reflect-ng-for-of": "[object Object]"
                             }-->
                          <div class="card journal-card ng-star-inserted">
                             <div class="card-header journal-header">
                                <a class="card-link" data-toggle="collapse" href="#JournalOne0" aria-expanded="true">
                                   <h3> Frontiers in Physiology</h3>
                                   <p>
                                      9 <span style="color:#4D4D4D;padding-right: 6px;" class="ng-star-inserted">Citations</span><span>(16% of all citations)</span>
                                   </p>
                                   <span class="icon"><i class="fa fa-caret-up"></i></span>
                                </a>
                             </div>
                             <div class="collapse" data-parent="#accordion10" id="JournalOne0" style="">
                                <div class="card-body">
                                   <div class="rf-accordion" id="accordion">
                                      <!--bindings={
                                         "ng-reflect-ng-for-of": "[object Object],[object Object"
                                         }-->
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen0">
                                               <ul class="icon-list">
                                                  <li>Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge medium-risk hide-li ng-star-inserted">Cited less than 3 times in a year</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="ng-star-inserted"><a class="read-more" href="javascript:void(0)"><span>+1 More</span></a></li>
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen0">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> The role of ion channels and transporters in cell proliferation and cancer</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Becchetti Andrea et al."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Becchetti Andrea et al. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Andrea Becchetti,Luca Munaron,"
                                                        }--><ul class="ng-star-inserted"><li>Andrea Becchetti</li></ul><ul class="ng-star-inserted"><li>Luca Munaron</li></ul><ul class="ng-star-inserted"><li>Annarosa Arcangeli</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen1">
                                               <ul class="icon-list">
                                                  <li>Jardín I, López JJ, Diez R, Sánchez-Collado J, Cantonero C, Albarrán L, et al. TRPs in pain sensation. Frontiers in physiology 2017; 8:392. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }-->
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen1">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> TRPs in Pain Sensation</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Jardín Isaac et al."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Jardín Isaac et al. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Isaac Jardín,José J. López,Raq"
                                                        }--><ul class="ng-star-inserted"><li>Isaac Jardín</li></ul><ul class="ng-star-inserted"><li>José J. López</li></ul><ul class="ng-star-inserted"><li>Raquel Diez</li></ul><ul class="ng-star-inserted"><li>José Sánchez-Collado</li></ul><ul class="ng-star-inserted"><li>Carlos Cantonero</li></ul><ul class="ng-star-inserted"><li>Letizia Albarrán</li></ul><ul class="ng-star-inserted"><li>Geoffrey E. Woodard</li></ul><ul class="ng-star-inserted"><li>Pedro C. Redondo</li></ul><ul class="ng-star-inserted"><li>Ginés M. Salido</li></ul><ul class="ng-star-inserted"><li>Tarik Smani</li></ul><ul class="ng-star-inserted"><li>Juan A. Rosado</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2017</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen2">
                                               <ul class="icon-list">
                                                  <li>Morris CE. Voltage-gated channel mechanosensitivity: fact or friction? Frontiers in physiology 2011; 2:25. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge medium-risk hide-li ng-star-inserted">Published 11 years ago</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen2">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Voltage-Gated Channel Mechanosensitivity: Fact or Friction?</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Morris Catherine E."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Morris Catherine E. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Catherine E. Morris"
                                                        }--><ul class="ng-star-inserted"><li>Catherine E. Morris</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2011</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen3">
                                               <ul class="icon-list">
                                                  <li>Heimo Mairbäurl. Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells. Frontiers in Physiology 2013. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }-->
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen3">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Red blood cells in sports: effects of exercise and training on oxygen supply by red blood cells</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Mairbäurl Heimo"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Mairbäurl Heimo 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Heimo Mairbäurl"
                                                        }--><ul class="ng-star-inserted"><li>Heimo Mairbäurl</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2013</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen4">
                                               <ul class="icon-list">
                                                  <li>Yuen K. Ip, and Shit F. Chew. Ammonia production, excretion, toxicity, and defense in fish: a review. Frontiers in Physiology 2010. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge medium-risk hide-li ng-star-inserted">Published 12 years ago</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen4">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Ammonia production, excretion, toxicity, and defense in fish: a review</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Ip Yuen"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Ip Yuen 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Yuen Ip"
                                                        }--><ul class="ng-star-inserted"><li>Yuen Ip</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2010</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen5">
                                               <ul class="icon-list">
                                                  <li>Djuna Z. de Back, Elena B. Kostova, Marian van Kraaij, Timo K. van den Berg and Robin van Bruggen. Of macrophages and red blood cells; a complex love story. Frontiers in Physiology 2014. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }-->
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen5">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Of macrophages and red blood cells; a complex love story</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "de Back Djuna Z. et al."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           de Back Djuna Z. et al. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Djuna Z. de Back,Elena B. Kost"
                                                        }--><ul class="ng-star-inserted"><li>Djuna Z. de Back</li></ul><ul class="ng-star-inserted"><li>Elena B. Kostova</li></ul><ul class="ng-star-inserted"><li>Marian van Kraaij</li></ul><ul class="ng-star-inserted"><li>Timo K. van den Berg</li></ul><ul class="ng-star-inserted"><li>Robin van Bruggen</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2014</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen6">
                                               <ul class="icon-list">
                                                  <li>SeongHun Yoon, Mario Zuccarello and Robert M. Rapoport. pCO2 and pH regulation of cerebral blood flow. Frontiers in Physiology 2010. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }-->
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen6">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> pCO2 and pH regulation of cerebral blood flow</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Yoon SeongHun et al."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Yoon SeongHun et al. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "SeongHun Yoon,Mario Zuccarello"
                                                        }--><ul class="ng-star-inserted"><li>SeongHun Yoon</li></ul><ul class="ng-star-inserted"><li>Mario Zuccarello</li></ul><ul class="ng-star-inserted"><li>Robert M. Rapoport</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2012</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen7">
                                               <ul class="icon-list">
                                                  <li>Gao, X.-h., Zhang, S.-s., Chen, H., Wang, Y.-H., Yuan, C.-H., and Wang, F.-B. Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection. (2017). Front. Physiol. 8:480. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge high-risk hide-li ng-star-inserted">Retracted after publication</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen7">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Retraction: Systemic Hepatic-Damage Index for Predicting the Prognosis of Hepatocellular Carcinoma after Curative Resection</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": ""
                                                     }-->
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2018</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                      <div class="card ng-star-inserted">
                                         <div class="card-header">
                                            <a class="card-link" data-toggle="collapse" href="#collapseTen8">
                                               <ul class="icon-list">
                                                  <li>Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway. Front. Physiol. 2021 11:718. </li>
                                               </ul>
                                            </a>
                                         </div>
                                         <div class="checklist-tags">
                                            <ul class="limitText" ng-reflect-ng-class="[object Object]">
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge low-risk ng-star-inserted">Publishing journal used too many times</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "false"
                                                  }--><!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="badge medium-risk hide-li ng-star-inserted">Cited less than 3 times in a year</li>
                                               <!--bindings={
                                                  "ng-reflect-ng-if": "true"
                                                  }-->
                                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                                            </ul>
                                         </div>
                                         <div class="collapse" data-parent="#accordion" id="collapseTen8">
                                            <div class="card-body">
                                               <div class="row">
                                                  <div class="col-12">
                                                     <p class="pc-para pc-title"><b>Title:</b><span> Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para"><b>Journal:</b><span> Frontiers in Physiology</span></p>
                                                  </div>
                                                  <!--bindings={
                                                     "ng-reflect-ng-if": "Sun Qin et al."
                                                     }-->
                                                  <div class="col-sm-12 ng-star-inserted">
                                                     <p class="pc-para">
                                                        <b>Author:</b>
                                                        <span class="popover-item">
                                                           Sun Qin et al. 
                                                     <div class="popover-content"><!--bindings={
                                                        "ng-reflect-ng-for-of": "Qin Sun,Tingxin Li,Yamei Li,Li"
                                                        }--><ul class="ng-star-inserted"><li>Qin Sun</li></ul><ul class="ng-star-inserted"><li>Tingxin Li</li></ul><ul class="ng-star-inserted"><li>Yamei Li</li></ul><ul class="ng-star-inserted"><li>Lingling Wei</li></ul><ul class="ng-star-inserted"><li>Min Zhang</li></ul><ul class="ng-star-inserted"><li>Shaoping Deng</li></ul></div></span></p>
                                                  </div>
                                                  <div class="col-12">
                                                     <p class="pc-para"><b>Published:</b><span> 2021</span></p>
                                                  </div>
                                               </div>
                                            </div>
                                         </div>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                </div>

                <!-- NonStandardReferences -->
                <div class="tab-pane" id="NonStandardReferences">
                  <div class="panel-card">
                    <h3>Non-Standard: 15 citations out of 54 <span class="badge high-risk">High Risk</span></h3>
                    <div class="warning mt-4 mb-4">
                        <div class="media">
                          <div class="media-left">
                            <img src="assets/images/Icon_Info.svg" alt="info">
                          </div>
                          <div class="media-body">
                            <p>A non-standard citations is one that is not an appropriately reviewed and published citations. This includes citations of personal communication, internet articles, discussions on forums, and similar non-reviewed sources. Journals prefer citations of standard published citations such as journal articles, books, and similar reviewed works. Only cite standard citations to the extent possible to avoid peer review critique. </p>
                          </div>
                        </div>
                    </div>

                    <div class="danger-outline mb-4 ">
                      Action Required: Replace these citations with standard citations such as published journal articles or books.
                    </div>

                    <div class="rf-accordion">
                        <div class="card ">
                          <div class="card-header">
                            <ul class="icon-list">
                                <li class="tx-14">Brohawn SG, del Mármol J, MacKinnon R. Crystal structure of the human K2P TRAAK, a lipid-and mechano-sensitive K+ ion channel. Science 2012; 335:436-41.</li>
                            </ul>
                          </div>
                          <div class="checklist-tags">
                            <ul class="limitText" >
                                <li class="badge high-risk ">Not a standard, reviewed publication</li>
                            </ul>
                          </div>
                      </div>
                      <div class="card ">
                          <div class="card-header">
                            <ul class="icon-list">
                                <li class="tx-14">B Bredeweg and  Marco Kragten. Requirements and Challenges for Hybrid Intelligence: a Case-study in Education. Front. Artif. Intell. Sec. AI for Human Learning and Behavior Change. 2022</li>
                            </ul>
                          </div>
                          <div class="checklist-tags">
                            <ul class="limitText" >
                                <li class="badge high-risk ">Not a standard, reviewed publication</li>
                            </ul>
                          </div>
                      </div>
                      <div class="card ">
                          <div class="card-header">
                            <ul class="icon-list">
                                <li class="tx-14">WHO Director-General’s opening remarks at the media briefing on COVID-19 - 11 March 2020.</li>
                            </ul>
                          </div>
                          <div class="checklist-tags">
                            <ul class="limitText" >
                                <li class="badge high-risk ">Not a standard, reviewed publication</li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PoorCitations -->
                <div class="tab-pane" id="PoorCitations">
                  <div class="panel-card">
                    <h3>Poorly Cited: 9 citations out of 54 <span class="badge medium-risk">Medium Risk</span></h3>
                    <div class="warning mt-4 mb-4">
                        <div class="media">
                          <div class="media-left">
                            <img src="assets/images/Icon_Info.svg" alt="info">
                          </div>
                          <div class="media-body">
                            <p>Poorly cited are those which have not been frequently cited by other authors, assessed as &lt;3 citations per year since publication. These may not add much credibility to your argumentation. However, newly published citations may not gather many citations; assess the report accordingly. </p>
                          </div>
                        </div>
                    </div>

                    <div class="danger-outline mb-4 ">
                      Action Required: Review these citations and replace with credible alternatives from other peer-reviewed journals.
                    </div>

                    <div class="rf-accordion" id="accordion">
                      <!--bindings={
                         "ng-reflect-ng-for-of": "[object Object],[object Object"
                         }-->
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen0">
                               <ul class="icon-list">
                                  <li >Alberts B, Johnson A, Lewis J, Raff M, Roberts K, Walter P. Ion channels and the electrical properties of membranes.  Molecular Biology of the Cell 4th edition: Garland Science, 2002. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk hide-li ng-star-inserted">Published 38 years ago</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen0">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Measuring the Properties of Single Channels in Cell Membranes</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Current Topics in Membranes an"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Current Topics in Membranes and Transport</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Kolb H.-A."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Kolb H.-A. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "H.-A. Kolb"
                                        }--><ul class="ng-star-inserted"><li >H.-A. Kolb</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 1984</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen1">
                               <ul class="icon-list">
                                  <li >Hodgkin AL, Huxley AF. Action potentials recorded from inside a nerve fibre. Nature 1939; 144:710-1. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk hide-li ng-star-inserted">Published 83 years ago</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen1">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Action Potentials Recorded from Inside a Nerve Fibre</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Nature"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Nature</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "HODGKIN A. L. et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           HODGKIN A. L. et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "A. L. HODGKIN,A. F. HUXLEY"
                                        }--><ul class="ng-star-inserted"><li >A. L. HODGKIN</li></ul><ul class="ng-star-inserted"><li >A. F. HUXLEY</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 1939</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen2">
                               <ul class="icon-list">
                                  <li >Rubaiy HN. A short guide to electrophysiology and ion channels. Journal of Pharmacy &amp; Pharmaceutical Sciences 2017; 20:48-67. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen2">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> A Short Guide to Electrophysiology and Ion Channels</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Journal of Pharmacy &amp; Phar"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Journal of Pharmacy &amp;amp; Pharmaceutical Sciences</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Rubaiy Hussein Nori"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Rubaiy Hussein Nori 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Hussein Nori Rubaiy"
                                        }--><ul class="ng-star-inserted"><li >Hussein Nori Rubaiy</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2017</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen3">
                               <ul class="icon-list">
                                  <li >Becchetti A, Arcangeli A. Integrins and ion channels in cell migration: implications for neuronal development, wound healing and metastatic spread.  Integrins and Ion Channels: Springer, 2010:107-23. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk hide-li ng-star-inserted">Published 12 years ago</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 1)"><span>+1 More</span></a></li>
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen3">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Integrins and Ion Channels in Cell Migration: Implications for Neuronal Development, Wound Healing and Metastatic Spread</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Advances in Experimental Medic"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Advances in Experimental Medicine and Biology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Becchetti Andrea et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Becchetti Andrea et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Andrea Becchetti,Annarosa Arca"
                                        }--><ul class="ng-star-inserted"><li >Andrea Becchetti</li></ul><ul class="ng-star-inserted"><li >Annarosa Arcangeli</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2010</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen4">
                               <ul class="icon-list">
                                  <li >Pla AF, Avanzato D, Munaron L, Ambudkar IS. Ion channels and transporters in cancer. 6. Vascularizing the tumor: TRP channels as molecular targets. American Journal of Physiology-Cell Physiology 2012; 302:C9-C15. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen4">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Ion channels and transporters in cancer. 6. Vascularizing the tumor: TRP channels as molecular targets</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "American Journal of Physiology"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> American Journal of Physiology-Cell Physiology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Pla Alessandra Fiorio et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Pla Alessandra Fiorio et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Alessandra Fiorio Pla,Daniele "
                                        }--><ul class="ng-star-inserted"><li >Alessandra Fiorio Pla</li></ul><ul class="ng-star-inserted"><li >Daniele Avanzato</li></ul><ul class="ng-star-inserted"><li >Luca Munaron</li></ul><ul class="ng-star-inserted"><li >Indu S. Ambudkar</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2012</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen5">
                               <ul class="icon-list">
                                  <li >Becchetti A, Munaron L, Arcangeli A. The role of ion channels and transporters in cell proliferation and cancer. Frontiers in physiology 2013; 4:312. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge low-risk hide-li ng-star-inserted">Published Journal used to many times</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen5">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> The role of ion channels and transporters in cell proliferation and cancer</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Becchetti Andrea et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Becchetti Andrea et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Andrea Becchetti,Luca Munaron,"
                                        }--><ul class="ng-star-inserted"><li >Andrea Becchetti</li></ul><ul class="ng-star-inserted"><li >Luca Munaron</li></ul><ul class="ng-star-inserted"><li >Annarosa Arcangeli</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2013</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen6">
                               <ul class="icon-list">
                                  <li >Trimmer JS. Ion channels and pain: Important steps towards validating a new therapeutic target for neuropathic pain. Experimental neurology 2014; 254:190. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen6">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Ion channels and pain: Important steps towards validating a new therapeutic target for neuropathic pain</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Experimental Neurology"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Experimental Neurology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Trimmer James S."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Trimmer James S. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "James S. Trimmer"
                                        }--><ul class="ng-star-inserted"><li >James S. Trimmer</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen7">
                               <ul class="icon-list">
                                  <li >Ranade Sanjeev&nbsp;S, Syeda R, Patapoutian A. Mechanically Activated Ion Channels. Neuron 2015; 87:1162-79. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen7">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Mechanically Activated Ion Channels</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Neuron"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Neuron</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Ranade Sanjeev&nbsp;S. et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Ranade Sanjeev&nbsp;S. et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Sanjeev&nbsp;S. Ranade,Ruhma Syeda,"
                                        }--><ul class="ng-star-inserted"><li >Sanjeev&nbsp;S. Ranade</li></ul><ul class="ng-star-inserted"><li >Ruhma Syeda</li></ul><ul class="ng-star-inserted"><li >Ardem Patapoutian</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2015</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "false"
                            }-->
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen8">
                               <ul class="icon-list">
                                  <li >Shah EA, Keren K. Mechanical forces and feedbacks in cell motility. Current opinion in cell biology 2013; 25:550-7. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen8">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Mechanical forces and feedbacks in cell motility</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Current Opinion in Cell Biolog"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Current Opinion in Cell Biology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Abu Shah Enas et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Abu Shah Enas et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Enas Abu Shah,Kinneret Keren"
                                        }--><ul class="ng-star-inserted"><li >Enas Abu Shah</li></ul><ul class="ng-star-inserted"><li >Kinneret Keren</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2013</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen9">
                               <ul class="icon-list">
                                  <li >Fuentes DE, Butler PJ. Coordinated mechanosensitivity of membrane rafts and focal adhesions. Cellular and molecular bioengineering 2012; 5:143-54. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen9">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Coordinated Mechanosensitivity of Membrane Rafts and Focal Adhesions</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Cellular and Molecular Bioengi"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Cellular and Molecular Bioengineering</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Fuentes Daniela E. et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Fuentes Daniela E. et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Daniela E. Fuentes,Peter J. Bu"
                                        }--><ul class="ng-star-inserted"><li >Daniela E. Fuentes</li></ul><ul class="ng-star-inserted"><li >Peter J. Butler</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2012</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen10">
                               <ul class="icon-list">
                                  <li >Liu X., Zhang Y., Liang H. and Xu Y. Overexpression of microRNA-216a-3p Accelerates the Inflammatory Response in Cardiomyocytes in Type 2 Diabetes Mellitus by Targeting IFN-α2. (2020) Front. Endocrinol. 11:522340. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen10">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Overexpression of microRNA-216a-3p Accelerates the Inflammatory Response in Cardiomyocytes in Type 2 Diabetes Mellitus by Targeting IFN-α2</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Frontiers in Endocrinology"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Frontiers in Endocrinology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Liu Xiaomeng et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Liu Xiaomeng et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Xiaomeng Liu,Yusong Zhang,Hong"
                                        }--><ul class="ng-star-inserted"><li >Xiaomeng Liu</li></ul><ul class="ng-star-inserted"><li >Yusong Zhang</li></ul><ul class="ng-star-inserted"><li >Hongwei Liang</li></ul><ul class="ng-star-inserted"><li >Yanchao Xu</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2020</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen11">
                               <ul class="icon-list">
                                  <li >Sun, Q., Li, T., Li, Y., Wei, L., Zhang, M., and Deng, S. Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway. Front. Physiol. 2021 11:718. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge low-risk hide-li ng-star-inserted">Published Journal used to many times</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="ng-star-inserted"><a class="read-more" (click)="showText($event, 2)"><span>+1 More</span></a></li>
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen11">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Bactericidal/Permeability-Increasing Protein Improves Cognitive Impairment in Diabetic Mice via Blockade of the LPS-LBP-TLR4 Signaling Pathway</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Frontiers in Physiology"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> Frontiers in Physiology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Sun Qin et al."
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para">
                                        <b >Author:</b>
                                        <span class="popover-item">
                                           Sun Qin et al. 
                                     <div class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Qin Sun,Tingxin Li,Yamei Li,Li"
                                        }--><ul class="ng-star-inserted"><li >Qin Sun</li></ul><ul class="ng-star-inserted"><li >Tingxin Li</li></ul><ul class="ng-star-inserted"><li >Yamei Li</li></ul><ul class="ng-star-inserted"><li >Lingling Wei</li></ul><ul class="ng-star-inserted"><li >Min Zhang</li></ul><ul class="ng-star-inserted"><li >Shaoping Deng</li></ul></div></span></p>
                                  </div>
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2021</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "true"
                            }-->
                         <div class="view-papers ng-star-inserted"><a data-target="#viewPapersModal" data-toggle="modal" href="#viewPapersModal">View papers citing this study</a></div>
                      </div>
                      <div class="card ng-star-inserted">
                         <div class="card-header">
                            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen12">
                               <ul class="icon-list">
                                  <li >Estruch R, et al. Primary Prevention of Cardiovascular Disease with a Mediterranean Diet. N ENGL J MED; APR 2013. </li>
                               </ul>
                            </a>
                         </div>
                         <div class="checklist-tags">
                            <ul class="limitText">
                               <!--bindings={
                                  "ng-reflect-ng-if": "true"
                                  }-->
                               <li class="badge medium-risk ng-star-inserted">Cited less than 3 times in a year</li>
                               <!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }--><!--bindings={
                                  "ng-reflect-ng-if": "false"
                                  }-->
                            </ul>
                         </div>
                         <div class="collapse" data-parent="#accordion" id="collapseSixteen12">
                            <div class="card-body">
                               <div class="row">
                                  <div class="col-12">
                                     <p class="pc-para pc-title"><b >Title:</b><span> Mediterranean Diet for Primary Prevention of Cardiovascular Disease</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "New England Journal of Medicin"
                                     }-->
                                  <div class="col-sm-12 ng-star-inserted">
                                     <p class="pc-para"><b >Journal:</b><span> New England Journal of Medicine</span></p>
                                  </div>
                                  <!--bindings={}-->
                                  <div class="col-12">
                                     <p class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <!--bindings={
                            "ng-reflect-ng-if": "false"
                            }-->
                      </div>
                   </div>
                  </div>
                </div>

                <!-- goodCitations -->
                <div class="tab-pane" id="goodCitations">
                  <div class="panel-card">
                    <h3>12 citations out of 54 are good to use</h3>
                    <p class="good-msg ng-star-inserted">These citations are good to use in your document.</p>

                    <div class="danger-outline mb-4 ">
                      Action Required: Review these citations and replace with credible alternatives from other peer-reviewed journals.
                    </div>

                    <div  class="rf-accordion" id="accordion">
                      <!--bindings={
                         "ng-reflect-ng-for-of": "[object Object],[object Object"
                         }-->
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen0">
                               <ul  class="icon-list">
                                  <li >Wemmie JA, Taugher RJ, Kreple CJ. Acid-sensing ion channels in pain and disease. Nature Reviews Neuroscience 2013; 14:461-71.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen0">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Acid-sensing ion channels in pain and disease</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Nature Reviews Neuroscience"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Nature Reviews Neuroscience</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Wemmie John A. et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Wemmie John A. et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "John A. Wemmie,Rebecca J. Taug"
                                        }--><ul  class="ng-star-inserted"><li >John A. Wemmie</li></ul><ul  class="ng-star-inserted"><li >Rebecca J. Taugher</li></ul><ul  class="ng-star-inserted"><li >Collin J. Kreple</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2013</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen1">
                               <ul  class="icon-list">
                                  <li >Tsantoulas C, McMahon SB. Opening paths to novel analgesics: the role of potassium channels in chronic pain. Trends in neurosciences 2014; 37:146-58.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen1">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Opening paths to novel analgesics: the role of potassium channels in chronic pain</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Trends in Neurosciences"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Trends in Neurosciences</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Tsantoulas Christoforos et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Tsantoulas Christoforos et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Christoforos Tsantoulas,Stephe"
                                        }--><ul  class="ng-star-inserted"><li >Christoforos Tsantoulas</li></ul><ul  class="ng-star-inserted"><li >Stephen B. McMahon</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen2">
                               <ul  class="icon-list">
                                  <li >Murthy SE, Loud MC, Daou I, Marshall KL, Schwaller F, Kühnemund J, et al. The mechanosensitive ion channel Piezo2 mediates sensitivity to mechanical pain in mice. Science translational medicine 2018; 10:eaat9897.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen2">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> The mechanosensitive ion channel Piezo2 mediates sensitivity to mechanical pain in mice</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Science Translational Medicine"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Science Translational Medicine</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Murthy Swetha E. et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Murthy Swetha E. et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Swetha E. Murthy,Meaghan C. Lo"
                                        }--><ul  class="ng-star-inserted"><li >Swetha E. Murthy</li></ul><ul  class="ng-star-inserted"><li >Meaghan C. Loud</li></ul><ul  class="ng-star-inserted"><li >Ihab Daou</li></ul><ul  class="ng-star-inserted"><li >Kara L. Marshall</li></ul><ul  class="ng-star-inserted"><li >Frederick Schwaller</li></ul><ul  class="ng-star-inserted"><li >Johannes Kühnemund</li></ul><ul  class="ng-star-inserted"><li >Allain G. Francisco</li></ul><ul  class="ng-star-inserted"><li >William T. Keenan</li></ul><ul  class="ng-star-inserted"><li >Adrienne E. Dubin</li></ul><ul  class="ng-star-inserted"><li >Gary R. Lewin</li></ul><ul  class="ng-star-inserted"><li >Ardem Patapoutian</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2018</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen3">
                               <ul  class="icon-list">
                                  <li >Jie Zheng, Trudeau MC. Handbook of Ion Channels. CRC Press, 2016.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen3">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Handbook of Ion Channels</span></p>
                                  </div>
                                  <!--bindings={}--><!--bindings={}-->
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2015</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen4">
                               <ul  class="icon-list">
                                  <li >Delmas P, Coste B. Mechano-gated ion channels in sensory systems. Cell 2013; 155:278-84.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen4">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Mechano-Gated Ion Channels in Sensory Systems</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Cell"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Cell</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Delmas Patrick et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Delmas Patrick et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Patrick Delmas,Bertrand Coste"
                                        }--><ul  class="ng-star-inserted"><li >Patrick Delmas</li></ul><ul  class="ng-star-inserted"><li >Bertrand Coste</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2013</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen5">
                               <ul  class="icon-list">
                                  <li >Moreau A, Gosselin-Badaroudine P, Chahine M. Biophysics, pathophysiology, and pharmacology of ion channel gating pores. Frontiers in pharmacology 2014; 5:53.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen5">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Biophysics, pathophysiology, and pharmacology of ion channel gating pores</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Frontiers in Pharmacology"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Frontiers in Pharmacology</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Moreau Adrien et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Moreau Adrien et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Adrien Moreau,Pascal Gosselin-"
                                        }--><ul  class="ng-star-inserted"><li >Adrien Moreau</li></ul><ul  class="ng-star-inserted"><li >Pascal Gosselin-Badaroudine</li></ul><ul  class="ng-star-inserted"><li >Mohamed Chahine</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen6">
                               <ul  class="icon-list">
                                  <li >Brohawn SG, Campbell EB, MacKinnon R. Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel. Nature 2014; 516:126.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen6">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Physical mechanism for gating and mechanosensitivity of the human TRAAK K+ channel</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Nature"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Nature</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Brohawn Stephen G. et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Brohawn Stephen G. et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Stephen G. Brohawn,Ernest B. C"
                                        }--><ul  class="ng-star-inserted"><li >Stephen G. Brohawn</li></ul><ul  class="ng-star-inserted"><li >Ernest B. Campbell</li></ul><ul  class="ng-star-inserted"><li >Roderick MacKinnon</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen7">
                               <ul  class="icon-list">
                                  <li >Kintzer AF, Green EM, Dominik PK, Bridges M, Armache J-P, Deneka D, et al. Structural basis for activation of voltage sensor domains in an ion channel TPC1. Proceedings of the National Academy of Sciences 2018; 115:E9095-E104.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen7">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Structural basis for activation of voltage sensor domains in an ion channel TPC1</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Proceedings of the National Ac"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Proceedings of the National Academy of Sciences</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Kintzer Alexander F. et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Kintzer Alexander F. et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Alexander F. Kintzer,Evan M. G"
                                        }--><ul  class="ng-star-inserted"><li >Alexander F. Kintzer</li></ul><ul  class="ng-star-inserted"><li >Evan M. Green</li></ul><ul  class="ng-star-inserted"><li >Pawel K. Dominik</li></ul><ul  class="ng-star-inserted"><li >Michael Bridges</li></ul><ul  class="ng-star-inserted"><li >Jean-Paul Armache</li></ul><ul  class="ng-star-inserted"><li >Dawid Deneka</li></ul><ul  class="ng-star-inserted"><li >Sangwoo S. Kim</li></ul><ul  class="ng-star-inserted"><li >Wayne Hubbell</li></ul><ul  class="ng-star-inserted"><li >Anthony A. Kossiakoff</li></ul><ul  class="ng-star-inserted"><li >Yifan Cheng</li></ul><ul  class="ng-star-inserted"><li >Robert M. Stroud</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2018</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen8">
                               <ul  class="icon-list">
                                  <li >Arrigoni C, Rohaim A, Shaya D, Findeisen F, Stein RA, Nurva SR, et al. Unfolding of a temperature-sensitive domain controls voltage-gated channel activation. Cell 2016; 164:922-36.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen8">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Unfolding of a Temperature-Sensitive Domain Controls Voltage-Gated Channel Activation</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Cell"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Cell</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Arrigoni Cristina et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Arrigoni Cristina et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Cristina Arrigoni,Ahmed Rohaim"
                                        }--><ul  class="ng-star-inserted"><li >Cristina Arrigoni</li></ul><ul  class="ng-star-inserted"><li >Ahmed Rohaim</li></ul><ul  class="ng-star-inserted"><li >David Shaya</li></ul><ul  class="ng-star-inserted"><li >Felix Findeisen</li></ul><ul  class="ng-star-inserted"><li >Richard&nbsp;A. Stein</li></ul><ul  class="ng-star-inserted"><li >Shailika&nbsp;Reddy Nurva</li></ul><ul  class="ng-star-inserted"><li >Smriti Mishra</li></ul><ul  class="ng-star-inserted"><li >Hassane&nbsp;S. Mchaourab</li></ul><ul  class="ng-star-inserted"><li >Daniel&nbsp;L. Minor</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2016</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen9">
                               <ul  class="icon-list">
                                  <li >Peyronnet R, Tran D, Girault T, Frachisse J-M. Mechanosensitive channels: feeling tension in a world under pressure. Frontiers in plant science 2014; 5:558.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen9">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Mechanosensitive channels: feeling tension in a world under pressure</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Frontiers in Plant Science"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Frontiers in Plant Science</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Peyronnet RÃ©mi et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Peyronnet RÃ©mi et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "RÃ©mi Peyronnet,Daniel Tran,Ti"
                                        }--><ul  class="ng-star-inserted"><li >RÃ©mi Peyronnet</li></ul><ul  class="ng-star-inserted"><li >Daniel Tran</li></ul><ul  class="ng-star-inserted"><li >Tiffanie Girault</li></ul><ul  class="ng-star-inserted"><li >Jean-Marie Frachisse</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2014</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen10">
                               <ul  class="icon-list">
                                  <li >Schmidt D, del Mármol J, MacKinnon R. Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K+ channels. Proceedings of the National Academy of Sciences 2012; 109:10352-7.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen10">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Mechanistic basis for low threshold mechanosensitivity in voltage-dependent K
                                        &lt;sup&gt;+&lt;/sup&gt;
                                        channels</span>
                                     </p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Proceedings of the National Ac"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Proceedings of the National Academy of Sciences</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Schmidt Daniel et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Schmidt Daniel et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Daniel Schmidt,Josefina del Má"
                                        }--><ul  class="ng-star-inserted"><li >Daniel Schmidt</li></ul><ul  class="ng-star-inserted"><li >Josefina del Mármol</li></ul><ul  class="ng-star-inserted"><li >Roderick MacKinnon</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2012</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen11">
                               <ul  class="icon-list">
                                  <li >Sukharev S, Sachs F. Molecular force transduction by ion channels–diversity and unifying principles. J Cell Sci 2012; 125:3075-83.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen11">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span>Molecular force transduction by ion channels – diversity and unifying principles</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Journal of Cell Science"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Journal of Cell Science</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Sukharev Sergei et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Sukharev Sergei et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Sergei Sukharev,Frederick Sach"
                                        }--><ul  class="ng-star-inserted"><li >Sergei Sukharev</li></ul><ul  class="ng-star-inserted"><li >Frederick Sachs</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2012</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen12">
                               <ul  class="icon-list">
                                  <li >Ridone P, Vassalli M, Martinac B. Piezo1 mechanosensitive channels: what are they and why are they important. Biophysical Reviews 2019; 11:795-805.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen12">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Piezo1 mechanosensitive channels: what are they and why are they important</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Biophysical Reviews"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Biophysical Reviews</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Ridone Pietro et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Ridone Pietro et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Pietro Ridone,Massimo Vassalli"
                                        }--><ul  class="ng-star-inserted"><li >Pietro Ridone</li></ul><ul  class="ng-star-inserted"><li >Massimo Vassalli</li></ul><ul  class="ng-star-inserted"><li >Boris Martinac</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2019</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen13">
                               <ul  class="icon-list">
                                  <li >Deng Z, Maksaev G, Schlegel AM, Zhang J, Rau M, Fitzpatrick JAJ, et al. Structural mechanism for gating of a eukaryotic mechanosensitive channel of small conductance. Nature Communications 2020; 11:3690.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen13">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Structural mechanism for gating of a eukaryotic mechanosensitive channel of small conductance</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Nature Communications"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Nature Communications</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Deng Zengqin et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Deng Zengqin et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Zengqin Deng,Grigory Maksaev,A"
                                        }--><ul  class="ng-star-inserted"><li >Zengqin Deng</li></ul><ul  class="ng-star-inserted"><li >Grigory Maksaev</li></ul><ul  class="ng-star-inserted"><li >Angela M. Schlegel</li></ul><ul  class="ng-star-inserted"><li >Jingying Zhang</li></ul><ul  class="ng-star-inserted"><li >Michael Rau</li></ul><ul  class="ng-star-inserted"><li >James A. J. Fitzpatrick</li></ul><ul  class="ng-star-inserted"><li >Elizabeth S. Haswell</li></ul><ul  class="ng-star-inserted"><li >Peng Yuan</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2020</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                      <div  class="card ng-star-inserted">
                         <div  class="card-header">
                            <a  class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen14">
                               <ul  class="icon-list">
                                  <li >Zhang W, Cheng LE, Kittelmann M, Li J, Petkovic M, Cheng T, et al. Ankyrin repeats convey force to gate the NOMPC mechanotransduction channel. Cell 2015; 162:1391-403.</li>
                               </ul>
                            </a>
                         </div>
                         <div  class="collapse" data-parent="#accordion" id="collapseSixteen14">
                            <div  class="card-body">
                               <div  class="row">
                                  <div  class="col-12">
                                     <p  class="pc-para pc-title"><b >Title:</b><span> Ankyrin Repeats Convey Force to Gate the NOMPC Mechanotransduction Channel</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Cell"
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para"><b >Journal:</b><span> Cell</span></p>
                                  </div>
                                  <!--bindings={
                                     "ng-reflect-ng-if": "Zhang Wei et al."
                                     }-->
                                  <div  class="col-sm-12 ng-star-inserted">
                                     <p  class="pc-para">
                                        <b >Author:</b>
                                        <span  class="popover-item">
                                           Zhang Wei et al. 
                                     <div  class="popover-content"><!--bindings={
                                        "ng-reflect-ng-for-of": "Wei Zhang,Li&nbsp;E. Cheng,Maike Ki"
                                        }--><ul  class="ng-star-inserted"><li >Wei Zhang</li></ul><ul  class="ng-star-inserted"><li >Li&nbsp;E. Cheng</li></ul><ul  class="ng-star-inserted"><li >Maike Kittelmann</li></ul><ul  class="ng-star-inserted"><li >Jiefu Li</li></ul><ul  class="ng-star-inserted"><li >Maja Petkovic</li></ul><ul  class="ng-star-inserted"><li >Tong Cheng</li></ul><ul  class="ng-star-inserted"><li >Peng Jin</li></ul><ul  class="ng-star-inserted"><li >Zhenhao Guo</li></ul><ul  class="ng-star-inserted"><li >Martin&nbsp;C. Göpfert</li></ul><ul  class="ng-star-inserted"><li >Lily&nbsp;Yeh Jan</li></ul><ul  class="ng-star-inserted"><li >Yuh&nbsp;Nung Jan</li></ul></div></span></p>
                                  </div>
                                  <div  class="col-12">
                                     <p  class="pc-para"><b >Published:</b><span> 2015</span></p>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                   </div>
                  </div>
                </div>

            </div>
        </div>
    </div>
  </div>
</section>
